<template>
  <form @submit.prevent="handleSubmit(item)" novalidate>
      <div :class="{ 'form-group': true, 'has-error': (errors && errors.name) }">
          <label for="_name" class="control-label">Nazwa</label>
          <b-form-input v-model="item.name" type="text" id="_name" ></b-form-input>
          <span v-if="errors && errors.name" class="help-block" id="_tax_helpBlock">{{ errors.name }}</span>
      </div>
      <div :class="{ 'form-group': true, 'has-error': (errors && errors.tax) }">
          <label for="_tax" class="control-label">Wartość podatku</label>
          <b-input-group right="%">
              <b-form-input v-model="item.tax" type="number" id="_amount" ></b-form-input>
          </b-input-group>
          <span v-if="errors && errors.tax" class="help-block" id="_tax_helpBlock">{{ errors.tax }}</span>
      </div>

    <router-link :to="{ name: 'InvoiceTaxTypeList' }" class="btn btn-primary"><span>Powrót</span><svg-icon name="back"/></router-link>
    <my-button text="Zapisz" icon="tick" type="submit" />
  </form>
</template>

<script>
  export default {
    props: {
      handleSubmit: {
        type: Function,
        required: true,
      },
      values: {
        type: Object,
        required: true
      },
      errors: {
        type: Object
      },
      initialValues: {
        type: Object
      }
    },
    computed: {
      item: function () {
        return this.initialValues ? this.initialValues : this.values;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Form.vue?9a9b153e